module.exports = __webpack_public_path__ + "970399ccd1d2d9b43a3c8a9e7d83d002.png";